// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'

import {
  SpanWithData,
  CurrencyInput,
  Input
} from '../'

import { showAsCurrency } from '../../utils'

export const LoanDetails = ({ creditType, eligibleFor, amount, instalment, cmsId, duplicateCmsId, handleChange, edit, onClick }) => {
  const isPositiveInteger = (value) => /^\d*$/.test(value)

  if (edit) {
    return (
      <tr>
        <td>
          <SpanWithData forField='CreditCreditType' searchKey={creditType} />
        </td>
        <td>
          {showAsCurrency('R', eligibleFor)}
        </td>
        <td>
          <CurrencyInput
            id='amount'
            value={amount || ''}
            onChange={handleChange}
            minValue={0}
          />
        </td>
        <td>
          <CurrencyInput
            id='instalmentAgreed'
            value={instalment || ''}
            onChange={handleChange}
            minValue={0}
          />
        </td>
        <td>
          <Input
            id='cmsId'
            value={isPositiveInteger(cmsId) ? cmsId : ''}  // necessary to correctly initialise first character entered
            onChange={e => {
              if (isPositiveInteger(e.target.value)) {
                handleChange(e)
              }
            }}
            hasError={duplicateCmsId !== null && duplicateCmsId === cmsId}
          />
        </td>
      </tr>
    )
  } else {
    return (
      <tr onClick={onClick}>
        <td>
          <SpanWithData forField='CreditCreditType' searchKey={creditType} />
        </td>
        <td>
          {showAsCurrency('R', eligibleFor)}
        </td>
        <td>
          {amount ? showAsCurrency('R', amount) : null}
        </td>
        <td>
          {instalment ? showAsCurrency('R', instalment) : ''}
        </td>
        <td>
          {cmsId}
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/creditapplication-requested-loan/LoanDetails.js